/**
 * Release Notes Static Data (Issue #933)
 *
 * Phase 1: Static TypeScript data file.
 * Phase 2: Will be replaced by API call to /api/content/release-notes
 *
 * Content matches docs/canonical/public/RELEASE_NOTES_v*.md files.
 *
 * v1.8.0 (Lumen) re-cut: the in-app Release Notes screen ships a single,
 * first-release-style entry. Historical public MD notes are archived under
 * docs/canonical/public/archive/ (out of the sync gate's maxdepth-1 glob).
 */

import type { ReleaseNote } from '../types/cms';

export const RELEASE_NOTES: ReleaseNote[] = [
  {
    version: 'v1.8.1',
    codename: 'Lumen',
    releaseDate: 'August 2026',
    isCurrent: true,
    summary:
      'Your club in one place: the people, the events, and the conversation. No feeds, no algorithms, no ads.',
    sections: [
      {
        id: 'your-club',
        title: 'Your club',
        blocks: [
          {
            type: 'list',
            items: [
              'Members, events, and one shared calendar',
              'Public, invite-only, or private',
              'Leaders to help you run it',
            ],
          },
        ],
      },
      {
        id: 'chat',
        title: 'Chat',
        blocks: [
          {
            type: 'list',
            items: [
              'A room for your club, and one for each event',
              'React to a message with a tap, twelve to choose from',
              'Leaders can pin one message per room',
            ],
          },
        ],
      },
      {
        id: 'events',
        title: 'Events',
        blocks: [
          {
            type: 'list',
            items: [
              'Create an event with the date, the place, and a cover photo',
              'RSVP yes, maybe, or no, and change your mind',
              'See who is coming',
              'Check people in when they arrive',
            ],
          },
        ],
      },
      {
        id: 'signing-in',
        title: 'Signing in',
        blocks: [
          {
            type: 'list',
            items: [
              'No password, ever',
              'A link by email, or a code by text',
            ],
          },
        ],
      },
      {
        id: 'about-our-texts',
        title: 'About our texts',
        blocks: [
          {
            type: 'list',
            items: [
              'Reply STOP and our texts stop, sign-in codes included',
              'Text START to turn them back on',
              'Choose which ones you get in Settings → Notifications',
            ],
          },
        ],
      },
    ],
  },
];
